export enum DashboardReducerKeys {
  CAMPAIGN_SUMMARY = "campaignSummary",
  UNIQUES_HISTOGRAM = "uniquesHistogram",
  REPORTS = "reports"
}
